/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import Flex from '../Flex';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';

export const AdvanceTableFooter = ({
  page,
  pageSize,
  pageIndex,
  rowCount,
  setPageSize,
  canPreviousPage,
  canNextPage,
  nextPage,
  previousPage,
  rowInfo,
  rowsPerPageSelection,
  navButtons,
  gotoPage,
  pageCount,
  AnInsertedRowInBackend,
  rowsPerPageOptions = [5, 10, 20, 30, 40, 50, 100],
  className
}) => {
  let ofPageItems = pageSize * pageIndex + page.length;
  if (AnInsertedRowInBackend) {
    ofPageItems = ofPageItems > rowCount ? rowCount : ofPageItems - 1;
  }
  else {
    ofPageItems = ofPageItems > rowCount ? rowCount : ofPageItems;
  }
  return (
    <Flex
      className={classNames(
        className,
        'align-items-center justify-content-between'
      )}
    >
      <Flex alignItems="center" className="fs--1">
        {rowInfo && (
          <p className="mb-0">
            <span className="d-none d-sm-inline-block me-2">
              {pageSize * pageIndex + 1} to {ofPageItems}{' '}
              of {rowCount}
            </span>
          </p>
        )}
        {rowsPerPageSelection && (
          <>
            <p className="mb-0 mx-2">Rows per page:</p>
            <Form.Select
              size="sm"
              className="w-auto"
              onChange={e => setPageSize(e.target.value)}
              defaultValue={pageSize}
            >
              {rowsPerPageOptions.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
      </Flex>
      {navButtons && (
        <Flex>
          {/* <Button
            size="sm"
            variant={canPreviousPage ? 'primary' : 'light'}
            onClick={() => previousPage()}
            className={classNames({ disabled: !canPreviousPage })}
          >
            Previous
          </Button> */}
          <AdvanceTablePagination
            pageIndex={pageIndex}
            gotoPage={gotoPage}
            pageCount={pageCount}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            previousPage={previousPage}
            nextPage={nextPage}
            pageSize={pageSize}
          ></AdvanceTablePagination>
          {/* <Button
            size="sm"
            variant={canNextPage ? 'primary' : 'light'}
            className={classNames('px-4 ms-2', {
              disabled: !canNextPage
            })}
            onClick={() => nextPage()}
          >
            Next
          </Button> */}
        </Flex>
      )}
    </Flex>
  );
};

export default AdvanceTableFooter;
